var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3608 19H5.26087C3.45989 19 2 17.5401 2 15.7391V4H21.6216V15.7391C21.6216 17.5401 20.1617 19 18.3608 19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93481 9.74373H5.91308"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.80892H21.5652"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54346 9.74373H8.52172"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1522 9.74373H11.1305"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7609 9.74373H13.7391"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3695 9.74373H16.3478"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6522 9.74373H18.9566"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93481 12.6785H5.91308"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54346 12.6785H8.52172"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1522 12.6785H11.1305"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7609 12.6785H13.7391"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3695 12.6785H16.3478"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6522 12.6785H18.9566"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93481 15.6134H5.91308"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54346 15.6134H8.52172"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1522 15.6134H11.1305"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7609 15.6134H13.7391"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Calendar.265b7d37.svg";
export { ForwardRef as ReactComponent };